import React, { useEffect, useState } from "react";
import { Select } from "antd";

/**
 * Componente Select asincrónico reutilizable
 *
 * @param {Function} loadOptionsFn - función async que devuelve las opciones [{label, value}]
 * @param {string} placeholder - texto del placeholder
 * @param {boolean} allowClear - si permite limpiar el valor
 * @param {boolean} searchEnabled - si permite busqueda
 * @param {object} selectProps - props adicionales del Select
 */
const AsyncSelect = ({
  loadOptionsFn,
  placeholder = "Seleccione una opción",
  allowClear = true,
  searchEnabled = true,
  value,           
  onChange,      
  selectProps = {},
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const load = async () => {
      try {
        const result = await loadOptionsFn();
        if (mounted) {
          setOptions(result);
        }
      } catch (error) {
        console.error("Error cargando opciones:", error);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    load();

    return () => {
      mounted = false;
    };
  }, [loadOptionsFn]);

  return (
    <Select
      value={value}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      loading={loading}
      allowClear={allowClear}
      showSearch={searchEnabled}
      optionFilterProp="label"
      filterOption={(input, option) =>
        option.label.toLowerCase().includes(input.toLowerCase())
      }
      {...selectProps}
    />
  );
};

export default AsyncSelect;
